import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
// import { ApiService } from '../../../services/api.service';
// import { environment } from '../../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { FileUpload } from 'primeng/fileupload';
import { EditorComponent } from '@tinymce/tinymce-angular';
// import { init } from '../../editorconfig';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { UploadService } from '../../services/upload/upload.service';
import { environment } from '../../../environments/environment';
import { init } from '../editorconfig';
import { DmsFile } from '../../modal/upload/model/upload.model';
// import { UploadService } from '../../../services/upload/upload.service';
// import { DmsFile } from '../../../modal/upload/model/upload.model';
@Component({
  selector: 'app-constitute-contract-negotiation-committee',
  standalone: false,
  templateUrl: './constitute-contract-negotiation-committee.component.html',
  styleUrl: './constitute-contract-negotiation-committee.component.scss'
})
export class ConstituteContractNegotiationCommitteeComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() step: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() id: any;
  apiUrl = environment.APIUrl
  commentForm: FormGroup;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @Output() stepCompleted = new EventEmitter<void>();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() schemeType: any;
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();

  @Output() submitProposal: EventEmitter<any> = new EventEmitter();
  selectedFile: File;
  filePathFromApi: string;
  payload: {
    proposal_id: any;
    proposal_name: any;
  };
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  @ViewChild('table') table: Table;
  vendors: any;
  resId: any;
  showDeleteDialog = false;
  selectedRow: any = null;
  private subscriptions = new Subscription();
  @Output() generatePDFEmitter = new EventEmitter<any>();
  userID: any;
  allDmsFiles: any[] = [];
  constructor(private fb: FormBuilder, private config: PrimeNGConfig,
    private messageService: MessageService, private api: ApiService,
    private uploadService: UploadService,
    private route: ActivatedRoute) {
    this.commentForm = this.fb.group({
      comment: ['', Validators.required]
    });
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName
      }
    });

    this.getNegotation();
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.stepDetails?.can_edit ) {
        this.isEditorDisabled = false;
        this.commentForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.commentForm.disable();
      }
      this.rebuildEditor()
    }, 3000);
  }
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled
    };
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }
  // onUpload(event: any) {
  //   //console.log(event);
  //   const file = event.files?.[0];
  //   if (file) {
  //     this.selectedFile = file;
  //     this.filePathFromApi = null;
  //   }
  // }

  getNegotation() {
    let url;
    if (this.schemeType == 'tdf') {
      url = `/tdf/cost-negotiation/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`
    } else if (this.schemeType == 'makeI') {
      url = `/make1/commercial-negotiation/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`
      // url = `/make1/make2/commercial-negotiation/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`
    }
    else if (this.schemeType == 'makeII' || this.schemeType == 'makeIII') {
      url = `/make1/make2/commercial-negotiation/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`
      //  url = `/make1/commercial-negotiation/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`
    }
    else if (this.schemeType == 'idex') {
      url = `/idex/commercial-negotiation/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`
    }
    else {
      url = `/revenue/commercial-negotiation/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`
    }

    const sub = this.api.getAPI(url).subscribe({
      next: (res) => {
        console.log("response Commercial", res)
        const dmsFiles: DmsFile[] = res.dms_files;
          this.allDmsFiles = dmsFiles;
        this.commentForm.patchValue({
          comment: res.justification
        });
        this.resId = res.id;
        this.vendors = [];

        // Set uploaded file URL if it exists
        if (res.file) {
          this.uploadedUrl = res.file;
          this.uploadedFileName = this.getFileName(res.file);
        }

        const resData = res.vendor || res.vendors;

        if (resData && typeof resData === 'object') {
          Object.keys(resData).forEach((vendorName) => {
            const vendorEntries = resData[vendorName];

            vendorEntries.forEach((entry: any) => {
              const vendorObj = entry.vendor || entry.da; // vendor key may not exist; use 'da'

              // Save final vendor (L1) to sessionStorage
              if (entry.level === 'L1' && vendorObj?.id) {
                sessionStorage.setItem('final_vendor', vendorObj.id);
              }

              this.vendors.push({
                vendor: vendorObj,
                finalPrice: entry.final_price || null,
                budget: entry.budgetary_quote || entry.benchmark_price || null,
                level: entry.level || '',
                vendor_status: entry.vendor_status || '',
                status: entry.vendor_status || '',
                id: entry.id || null,
                date: entry.commercial_date
              });
            });
          });
        }
      },
      error: (err) => {
        console.error('Error fetching benchmark data:', err);
      }
    });
    this.subscriptions.add(sub);
  }
    // this is use for upload document table
  onDocumentUpload(data: any) {
    console.log('>>>>data from upload', data);
    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('name', data.name);
    formData.append('description', data.description);
    formData.append('file', data.file);

    // ✅ Use your service method here
    this.uploadService.uploadneedGenData(formData).subscribe({
      next: (res: any) => {
        console.log('>>>>>>res need upload data', res);
      },
      error: (err) => {
        console.error('❌ Upload failed:', err);
      }
    });

  }

  onDocumentEdited(updatedDoc: any) {
    console.log('✏️ Edited document from child:', updatedDoc);

    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('name', updatedDoc.name);
    formData.append('description', updatedDoc.description);

    // Only append file if it's a new file (File object)
    if (updatedDoc.file instanceof File) {
      formData.append('file', updatedDoc.file);
    }

    // ✅ Update API call
    this.uploadService.updateUploadNeedGenData(updatedDoc.id, formData).subscribe({
      next: (response: any) => {
        console.log('✅ Document updated successfully:', response);

        // ✅ Replace the updated record instead of pushing new
        const index = this.allDmsFiles.findIndex((d) => d.id === updatedDoc.id);
        if (index !== -1) {
          // Update the existing record
          this.allDmsFiles[index] = { ...this.allDmsFiles[index], ...updatedDoc };
        }
      },
      error: (err) => {
        console.error('❌ Update failed:', err);
      },
    });
  }

  onDocumentDeleted(docId: number) {
    console.log('🗑️ Deleted document ID from child:', docId);

    this.uploadService.deleteUploadNeedGenData(docId).subscribe({
      next: (res: any) => {
        console.log('delete uploadData', res);
      },
      error: (err) => {
        console.error('❌ Upload failed:', err);
      }
    })

    // Optionally call delete API
  }
  extractFileName(filePath: string): string {
    // return filePath.split('/').pop() || 'download';
    const fileName = filePath.split('/').pop() || '';
    return fileName.length > 35 ? fileName.substring(0, 35) + '...' : fileName;
  }

  onRowEditInit(rowData: any) {
    rowData.originalData = { ...rowData };
  }

  onRowEditSave(rowData: any) {
    if (!this.validateLevel(rowData)) {
      // Don't proceed if level is invalid
      return;
    }

    const formData = new FormData();
    formData.append('proposal_step', this.step.id);

    if (this.schemeType === 'makeI') {
      formData.append('vendor_id', rowData.id);
    } else if (this.schemeType == 'makeII' || this.schemeType == 'makeIII') {
      formData.append('vendor_id', rowData.id);
    }
    else {
      formData.append('vendor_id', rowData.id);
    }

    formData.append('level', rowData.level);
    formData.append('final_price', rowData.finalPrice);
    if (rowData.date) {
      formData.append('commercial_date', rowData.date);
    }

    let url;
    if (this.schemeType === 'tdf') {
      url = `/tdf/cost-negotiation/`;
    } else if (this.schemeType === 'makeI') {
      url = `/make1/commercial-negotiation/`;
    } else if (this.schemeType === 'makeII' || this.schemeType == 'makeIII') {
      url = `/make1/make2/commercial-negotiation/`;
    }
    else if (this.schemeType == 'idex') {
      url = `/idex/commercial-negotiation/`;
    } else {
      url = `/revenue/commercial-negotiation/`;
    }

    this.api.putAPI(url, formData).subscribe((res: any) => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: res.message || 'Data updated successfully'
      });
      this.getNegotation();
      this.table.cancelRowEdit(rowData);
    });
  }


  onRowEditCancel(rowData: any, index: number) {
    // Revert to original data
    if (rowData.originalData) {
      this.vendors[index] = { ...rowData.originalData };
    }
  }
  onFileUpload(event: any, rowData: any): void {
    const file = event.target.files[0];
    if (file) {
      rowData.uploadedFile = file;
      rowData.uploadedFileName = file.name;
    }
  }
  selectedVendor: any = null;

  onSubmit() {
    const justification = this.commentForm.get('comment')?.value;
    let url;
    if (this.schemeType == 'tdf') {
      url = `/tdf/cost-negotiation/${this.resId}/`
    } else if (this.schemeType == 'makeI') {
      url = `/make1/commercial-negotiation/${this.resId}/`
    } else if (this.schemeType == 'makeII' || this.schemeType == 'makeIII') {
      url = `/make1/make2/commercial-negotiation/${this.resId}/`
    }
    else if (this.schemeType == 'idex') {
      url = `/idex/commercial-negotiation/${this.resId}/`;
    }
    else {
      url = `/revenue/commercial-negotiation/${this.resId}/`
    }

    // Create FormData to handle both text and file data
    const formData = new FormData();
    formData.append('justification', justification);

    // Add file if it exists
    if (this.file) {
      formData.append('file', this.file);
    }

    const sub = this.api.putAPI(url, formData).subscribe({
      next: () => {
        this.getNegotation()
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `Justification and document submitted successfully`
        });
        // Clear the file after successful upload
        this.file = null;
        this.uploadedFileName = '';
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `Failed to submit justification and document`
        });
      }
    });
    this.subscriptions.add(sub);
  }

  openDeleteDialog(rowData: any) {
    this.selectedRow = rowData;
    this.showDeleteDialog = true;
  }

  confirmDelete() {

    let sectionId = this.selectedRow.id
    let url;
    if (this.schemeType == 'tdf') {
      url = `/tdf/cost-negotiation/?vendor_id=${sectionId}`
    } else if (this.schemeType == 'makeI') {
      url = `/make1/commercial-negotiation/?vendor_id=${sectionId}`
    } else if (this.schemeType == 'idex') {
      url = `/idex/commercial-negotiation/?vendor_id=${sectionId}`
    }
    else {
      url = `/revenue/commercial-negotiation/?vendor_id=${sectionId}`
    }
    const sub = this.api.deleteAPI(url).subscribe({
      next: (res: any) => {
        //console.log(res);
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Vendor Deleted Successfully',
        });
        this.showDeleteDialog = false;
        this.getNegotation();
      },
      error: (err) => {
        console.error('API Error:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to delete the Unit. Please try again.',
        });
      },
    });
    this.subscriptions.add(sub);
    this.showDeleteDialog = false;
  }
  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: "Proposal Name", value: this.payload.proposal_name },
        { key: "Comments", value: this.commentForm.get('comment')?.value },

      ]
    };
    this.generatePDFEmitter.emit(payload);
  }
  //     validateLevel(rowData: any) {
  //   const pattern = /^L[1-9][0-9]*$/;
  //   if (!pattern.test(rowData.level)) {
  //     // Reset or show error
  //     rowData.level = '';
  //     alert('Only values like L1, L2, L3 are allowed.');

  //   }
  // }
  validateLevel(rowData: any): boolean {
    const pattern = /^L[1-9][0-9]*$/;
    if (!pattern.test(rowData.level)) {
      rowData.level = '';
      // alert('Only values like L1, L2, L3 are allowed.');
      this.messageService.add({
        severity: 'fail',
        summary: 'Fail',
        detail: `Only values like L1, L2, L3 are allowed.`
      });
      return false;
    }
    return true;
  }

  uploadedFileName: string = '';
  uploadedUrl: string = '';
  file: File | null = null;

  onUpload(event: any) {
    this.file = event.files[0];
    if (this.file) {
      this.uploadedFileName = this.file.name;
      this.uploadedUrl = ''; // Clear existing URL when new file is selected
      console.log('File selected:', this.file.name);
    }
  }

  clearUpload(fileUpload: any) {
    // Clear all file-related states
    this.uploadedUrl = '';
    this.uploadedFileName = '';
    this.file = null;
    fileUpload.clear();
  }
  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }


    
//    visible: boolean = false;
//   confirmChecked=false;

//   showConfirm() {
//       if (!this.visible) {
//           this.confirmChecked = false; // Reset checkbox when opening the modal
//           this.messageService.add({ key: 'confirm', sticky: true, severity: 'info', summary: 'Are you sure you want to submit this proposal?' });
//           this.visible = true;
//       }
//   }

//     onReject() {
//       this.messageService.clear('confirm');
//       this.visible = false;
//       this.confirmChecked = false; // Reset checkbox when closing the modal
//   }
// submitIRA() {
//   const iraPayload = {
//     proposal_step: this.id, // Using the component's id which seems to be proposal_step
//     // user: this.userID, // From your component
//     // user : parseInt(this.userID),
//     user : sessionStorage.getItem('user_id'),
//     approve_status: 1, // 1 for accept, 2 for reject
//     final_approval: this.confirmChecked ? 1 : 0, // Convert boolean to 1/0
//     remark: "", 
//     unit: sessionStorage.getItem('unit_id'),
    
//     // unit: this.challengeForm.get('coordinatingAgency')?.value || 2 // Using coordinating agency or default
//   };
//   console.log("unit id is", iraPayload.unit);
//   const sub = this.api.postAPI('/transaction/copy/proposal-ira-action/',
//     iraPayload
//   ).subscribe({
//     next: (response: any) => {
//       this.messageService.add({
//         severity: 'success',
//         summary: 'Success',
//         detail: 'IRA action submitted successfully',
//       });
//       // Emit the IRA data if needed by parent component
//       this.IRA.emit(response);
//       console.log('IRA submission response:', response);
//     },
//     error: (err) => {
//       console.error('IRA submission failed:', err);
//       this.messageService.add({
//         severity: 'error',
//         summary: 'Error',
//         detail: 'Failed to submit IRA action',
//       });
//     }
//   });
  
//   this.subscriptions.add(sub);
// }
//   onConfirm() {
//       this.messageService.clear('confirm');
//       this.visible = false;
//       this.onSubmit(); 
//       console.log("hiiiii")
//       this.submitIRA();
//       this.routeConfig.emit({isRouteConfig: true, isFinalApproval: this.confirmChecked});
//   }

 
//    routeconfig() {
//       console.log('routeconfig');
//       this.messageService.clear('confirm');
//       this.visible = false;
//       this.confirmChecked = false; // Reset checkbox when closing the modal
//       this.routeConfig.emit({isRouteConfig: false});
//   }


  

}
